import { SVGProps } from 'react';

const MoveDiagonal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 13v6h6m-6 0L19 5m0 6V5h-6"
    />
  </svg>
);
export default MoveDiagonal;
